<div class="topbar-container">
  <div class="left-area">
    <div
      #menuRef
      class="hambuger"
      (click)="this.toggleSidebar_()"
    
    >
    <img src="../../../../../assets/icons/hamburger.svg" alt="">
      <div class="h1"></div>
      <div class="h2"></div>
    </div>

    <!-- <img
      class="logo"
      routerLink="/dashboard"
      src="assets/images/insured-logo.png"
    /> -->

    <p class="page-title">{{this.title}}</p>
    <!-- <div class="back-btn">
      <div class="back-icon">
        <img src="assets/images/arrow-back.svg" />
      </div>
      <span>Back</span>
    </div> -->
    <!-- <div class="back-btn">
      <div class="back-icon">
        <img src="assets/images/arrow-back.svg" />
      </div>
      <span>Back</span>
    </div> -->
  </div>
  <div class="profile-area">
    <!-- <span class="avatar-container"> </span> -->
 
    <div class="details-container ">
      <div class="details">
        <span class="name">{{this.userData.companyName}}</span>
        <!-- <span class="role">S]]n</span> -->
      </div>
      <div class="dropdown">
      <img (click)="openDropdown()"  src="../../../../../assets/icons/chevron.svg" alt="">
      <div *ngIf="isDropdownOpen" class="dropdown-body">
        <!-- <a (click)="showModal()">Update Password</a> -->
        <a class="dropdown-link" (click)="logout()">Logout</a>
      </div>
    </div>
    </div>
 
   
  </div>
</div>


